"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ascoli-piceno": {
    "8154eaa9": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "bivio-giustimana": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0972e058": [{
      "hkey": "e2c4bef7",
      "slug": "borgo-solesta-campo-parignano",
      "name": "Borgo Solestà-Campo Parignano",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-solesta": [{
      "hkey": "e2c4bef7",
      "slug": "borgo-solesta-campo-parignano",
      "name": "Borgo Solestà-Campo Parignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "d52830c8": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "skipSearch": false
    }],
    "caldaie": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "6972052a": [{
      "hkey": "e2c4bef7",
      "slug": "borgo-solesta-campo-parignano",
      "name": "Borgo Solestà-Campo Parignano",
      "primary": true,
      "skipSearch": false
    }],
    "campo-parignano": [{
      "hkey": "e2c4bef7",
      "slug": "borgo-solesta-campo-parignano",
      "name": "Borgo Solestà-Campo Parignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "6e8868bc": [{
      "hkey": "7475ad07",
      "slug": "campolungo-villa-sant-antonio",
      "name": "Campolungo-Villa Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "campolungo": [{
      "hkey": "7475ad07",
      "slug": "campolungo-villa-sant-antonio",
      "name": "Campolungo-Villa Sant'Antonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0218caef": [{
      "hkey": "e2c4bef7",
      "slug": "borgo-solesta-campo-parignano",
      "name": "Borgo Solestà-Campo Parignano",
      "primary": true,
      "skipSearch": false
    }],
    "caprignano": [{
      "hkey": "e2c4bef7",
      "slug": "borgo-solesta-campo-parignano",
      "name": "Borgo Solestà-Campo Parignano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "2c6e2f4c": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "casa-circondariale": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da590323": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "casamurana": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a3483e7a": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "case-di-coccia": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8e9078c": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "castel-di-lama-stazione": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c4b1c3e4": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "colloto": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4f686e52": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "colonnata": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cd8660ca": [{
      "hkey": "16db2a38",
      "slug": "monticelli",
      "name": "Monticelli",
      "primary": true,
      "skipSearch": false
    }],
    "croce-di-tolignano": [{
      "hkey": "16db2a38",
      "slug": "monticelli",
      "name": "Monticelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "7f38f282": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "lago": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a48c2db0": [{
      "hkey": "756dd907",
      "slug": "marino-del-tronto",
      "name": "Marino del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "lu-battente": [{
      "hkey": "756dd907",
      "slug": "marino-del-tronto",
      "name": "Marino del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "80cd1831": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "monte-di-rosara": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "14ceb142": [{
      "hkey": "16db2a38",
      "slug": "monticelli",
      "name": "Monticelli",
      "primary": true,
      "skipSearch": false
    }],
    "monticelli-alto": [{
      "hkey": "16db2a38",
      "slug": "monticelli",
      "name": "Monticelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "c7b1e347": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "oleificio-panichi": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d1961781": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "palombare": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca0740f7": [{
      "hkey": "756dd907",
      "slug": "marino-del-tronto",
      "name": "Marino del Tronto",
      "primary": true,
      "skipSearch": false
    }],
    "periferico": [{
      "hkey": "756dd907",
      "slug": "marino-del-tronto",
      "name": "Marino del Tronto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "50a10ed7": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "skipSearch": false
    }],
    "piazza-immacolata": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "04204c2e": [{
      "hkey": "123008eb",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "skipSearch": false
    }],
    "piazzarola": [{
      "hkey": "123008eb",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "6a094ac8": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "polesio": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0fd2d3d5": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "porchiano": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2d376954": [{
      "hkey": "90e99f50",
      "slug": "borgo-cartaro",
      "name": "Borgo Cartaro",
      "primary": true,
      "skipSearch": false
    }],
    "porta-cartara": [{
      "hkey": "90e99f50",
      "slug": "borgo-cartaro",
      "name": "Borgo Cartaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "c7aa9b40": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "skipSearch": false
    }],
    "san-filippo": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "e3f30306": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "san-pietro": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d5ddaaef": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-a-corte": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "40314129": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "skipSearch": false
    }],
    "tofare": [{
      "hkey": "4c370dca",
      "slug": "porta-maggiore",
      "name": "Porta Maggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "527c40ce": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "valle-fiorana": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "526434c3": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "valle-venere": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "db955082": [{
      "hkey": "7475ad07",
      "slug": "campolungo-villa-sant-antonio",
      "name": "Campolungo-Villa Sant'Antonio",
      "primary": true,
      "skipSearch": false
    }],
    "villa-sant-antonio": [{
      "hkey": "7475ad07",
      "slug": "campolungo-villa-sant-antonio",
      "name": "Campolungo-Villa Sant'Antonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "ascoli-piceno"
    }],
    "54803fcf": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "skipSearch": false
    }],
    "zona-stazione": [{
      "hkey": "87920917",
      "slug": "ascoli-piceno",
      "name": "Ascoli Piceno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;